import { InformationIcon } from './InformationIcon';

/**
 * author: Google
 * id 2BC4A4B6-119B-4637-BF3D-1FB9394E1F38
 * name information
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information.svg
 * tags
 * - Settings 
 */
export const InfoCircleIcon = InformationIcon;
export default InfoCircleIcon